import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mwe-availability-badge',
  templateUrl: './availability-badge.component.html',
  imports: [NgClass, NgbTooltip],
})
export class AvailabilityBadgeComponent {
  badgeMessage: string;
  availabilityIconURL: string;

  @Input() activeBadge = true;
  @Input() inactiveBadge = false;
  @Input() unknownBadge = false;
  @Input() hoverMessage: string;
  @Input() activeLabel = 'Aktiv';
  @Input() unknownLabel = 'Versorgung möglich';
  @Input() inactiveLabel = 'Inaktiv';
  @Input() customCss: string;

  getAvailabilityIcon(): string {
    this.availabilityIconURL = this.unknownBadge
      ? 'info-icon.svg'
      : this.activeBadge
        ? 'checkmark-icon.svg'
        : this.inactiveBadge
          ? 'cross-icon.svg'
          : null;
    return this.availabilityIconURL;
  }

  getAvailabilityBadgeMessage(): string {
    this.badgeMessage = this.unknownBadge
      ? this.unknownLabel
      : this.activeBadge
        ? this.activeLabel
        : this.inactiveBadge
          ? this.inactiveLabel
          : null;
    return this.badgeMessage;
  }
}
